import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import postHouseholdMember from "../requests/postHouseholdMember";
import { getHouseholdKeyMaker } from "./useGetHousehold";
import { getHouseholdsKeyMaker } from "./useGetHouseholds";
const IDEMPOTENCY_DESCRIPTOR = "post-household-member";
const usePostHouseholdMember = (config) => {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ householdId, body }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            // Include householdId & clientId in the idempotency key for better uniqueness
            const idempotencyKeyWithHouseholdId = `${idempotencyKey}-${householdId}-${body.clientId}`;
            return postHouseholdMember(householdId, body, idempotencyKeyWithHouseholdId, config);
        },
        onMutate: ({ householdId, body }) => {
            const previousHousehold = queryClient.getQueryData(getHouseholdKeyMaker(householdId));
            if (previousHousehold) {
                queryClient.setQueryData(getHouseholdKeyMaker(householdId), {
                    ...previousHousehold,
                    members: [
                        ...(previousHousehold?.members ? previousHousehold.members : []),
                        {
                            clientId: body.clientId,
                            memberType: body.memberType,
                            pointOfContact: body.pointOfContact,
                        },
                    ],
                });
            }
            return { previousHousehold };
        },
        onError: (_, { householdId }, context) => {
            // Rollback the optimistic update if the mutation fails
            if (context?.previousHousehold) {
                queryClient.setQueryData(getHouseholdKeyMaker(householdId), context.previousHousehold);
            }
        },
        onSuccess: (_, { householdId }) => {
            queryClient.invalidateQueries({
                queryKey: getHouseholdsKeyMaker(null),
            });
            queryClient.invalidateQueries({
                queryKey: getHouseholdKeyMaker(householdId),
            });
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePostHouseholdMember;
//# sourceMappingURL=usePostHouseholdMember.js.map